import spinner from "./../templates/spinner.dust";

export default class Loader {
  DOMContainer = null;

  constructor() {
    this.DOMContainer = document.querySelector("#loader");
    this.render();
  }

  render() {
    Dust.render(spinner, {}, (err, result) => {
      this.DOMContainer.innerHTML = result;
    });
  }

  show() {
    if (this.DOMContainer) {
      this.DOMContainer.classList.remove("hidden");
    }
  }

  hide() {
    if (this.DOMContainer) {
      this.DOMContainer.classList.add("hidden");
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/loader.js